import { gql } from "@apollo/client";

export const SEARCH_INITIATIVE = gql`
  query SearchInitiatives($search: String) {
    searchInitiatives(search: $search) {
      id
      serviceId
      organizationId
      name
      description
      address
      images
      joinDate
      service {
        location {
          city
          country
        }
      }
      organizations {
        id
        logoUrl
        name
      }
    }
  }
`;
